class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Hover-to-open is only sensible on devices with a real pointer.
    // Touch devices (hover: none) would auto-open on tap and fight the
    // native click-to-toggle behavior of <details>/<summary>.
    this.hoverSupported = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (this.hoverSupported) {
      this._closeTimer = null;
      this.addEventListener('mouseenter', this.onHoverEnter.bind(this));
      this.addEventListener('mouseleave', this.onHoverLeave.bind(this));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onHoverEnter() {
    clearTimeout(this._closeTimer);
    if (this.mainDetailsToggle.open) return;
    // Close any sibling menu that's currently open so we don't end up
    // with two dropdowns visible at once.
    document.querySelectorAll('header-menu').forEach((el) => {
      if (el !== this) el.close();
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
  }

  onHoverLeave() {
    // Small grace period so a quick pointer dip between the summary and
    // the panel content doesn't immediately close the menu.
    clearTimeout(this._closeTimer);
    this._closeTimer = setTimeout(() => {
      // Don't close if focus is still inside (keyboard user mid-navigation).
      if (this.contains(document.activeElement)) return;
      this.close();
    }, 180);
  }
}

customElements.define('header-menu', HeaderMenu);
